export function normalizePaths(input) {
  if (Array.isArray(input)) {
    return input
      .filter((path) => path !== undefined && path !== null && path !== "")
      .map((path) => String(path));
  }
  if (typeof input === "string") {
    if (!input) return [];
    return [String(input)];
  }
  return [];
}

function unwrap(res) {
  if (!res) return res;
  if (Object.prototype.hasOwnProperty.call(res, "ok")) {
    if (res.data !== undefined && res.data !== null) return res.data;
    return res;
  }
  return res;
}

export async function tryRequests(paths, handler) {
  const pathList = normalizePaths(paths);
  if (!pathList.length) {
    throw new Error("No API paths provided for request");
  }
  let lastResult = null;

  for (const p of pathList) {
    try {
      const res = await handler(p);
      lastResult = res;

      if (res?.ok === false) continue;
      return unwrap(res);
    } catch (e) {
      lastResult = e;
      continue;
    }
  }

  if (lastResult instanceof Error) throw lastResult;
  return lastResult;
}
